import classNames from 'classnames';
import { FC } from 'react';
import Link from 'next/link';

import { useHubSwitch } from '@bpm-web-app/utils';
import { Account, AccountPageProps } from '../account';
import IconExternalLink from '../components/icons/external-link.svg';
import styles from './account-overview.module.css';
import { PersonalInfo } from './personal-info/personal-info';
import { SECTIONS } from './sections';
import { YourPlan } from './your-plan/your-plan';

export const AccountOverview: FC<AccountPageProps> = ({ title }) => {
    const { isCreate } = useHubSwitch();

    return (
        <Account title={title}>
            <PersonalInfo />
            <YourPlan />

            {SECTIONS(isCreate).map((section, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <section key={index} className={styles['account__section']}>
                    {!!section.title && <h2 className={styles['account__section-title']}>{section.title}</h2>}

                    <ul className={styles['account__menu']}>
                        {section.items.map((menuItem) => menuItem.filter !== false && (
                            <li key={menuItem.label} className={styles['account__menu-item']}>
                                <Link href={menuItem.link}>
                                    <a className={classNames(styles['account__menu-link'], { [styles['account__menu-link--external']]: menuItem.isExternal })}>
                                        <menuItem.icon className={styles['account__menu-icon']} />
                                        <span>{menuItem.label}</span>
                                        {menuItem.isExternal && <IconExternalLink className={classNames(styles['account__menu-icon'], styles['account__menu-icon--external'])} />}
                                    </a>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </section>
            ))}
        </Account>
    );
};
